if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.stickySubmitButton = document.getElementById(`ProductStickySubmitButton-${this.dataset.sectionId}`);

        if(this.stickySubmitButton) {
            this.stickySubmitButtonText = this.stickySubmitButton.querySelector('span');
            this.stickySubmitButtonLoadingSpinner = this.stickySubmitButton.querySelector('.loading__spinner');
        }

        this.selectors = {
          membershipProductsJSON: '.js-membership-products-json',
          membershipServiceCard: '.js-membership-service-card',
          activeMembershipServiceCard: '.js-membership-service-card.is-active',
          membershipServiceTabButton: '.js-membership-service-tab-button',
          activeMembershipServiceTabButton: '.js-membership-service-tab-button.is-active',
          membershipServiceCardCompareAtPrice: '.js-membership-service-card-compare-at-price',
          membershipServiceCardPrice: '.js-membership-service-card-price',
          membershipServiceCardPriceDuration: '.js-membership-service-card-price-duration',
          membershipDoubleCheckText: '.js-membership-double-check-text',
        };

        this.classes = {
          isActive: 'is-active',
          isHidden: 'hide'
        }

        this.membershipProducts = [];
        this.membershipServiceCards = [];
        this.membershipServiceTabButtons = [];
        this.activeMembershipServiceCard = this.querySelector(this.selectors.activeMembershipServiceCard);
        this.activeMembershipServiceTabButton = this.querySelector(this.selectors.activeMembershipServiceTabButton);
        this.doubleCheckText = this.querySelector(this.selectors.membershipDoubleCheckText);
        this.sellingPlanFormInput = this.form.querySelector('input[name="selling_plan"]');

        if (document.querySelector('cart-drawer')) {
           this.submitButton.setAttribute('aria-haspopup', 'dialog');

           if(this.stickySubmitButton) {
            this.stickySubmitButton.setAttribute('aria-haspopup', 'dialog');
           }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.initMembershipProducts();
        this.initMembershipServiceCards();

        if (!this.membershipProducts.length || !this.membershipServiceCards.length) return;

        this.initMembershipServiceTabButtons();
      }

      initMembershipProducts() {
        const membershipProductsJSON = this.querySelector(this.selectors.membershipProductsJSON);

        if (!membershipProductsJSON) return;

        try {
          this.membershipProducts = JSON.parse(membershipProductsJSON.innerText).products;
        } catch (error) {
          console.error(`Membership service::ERROR::${error.message}`);
        }
      }

      initMembershipServiceCards() {
        const membershipServiceCards = [...this.querySelectorAll(this.selectors.membershipServiceCard)];

        if (!membershipServiceCards.length) return;

        this.membershipServiceCards = membershipServiceCards;

        this.membershipServiceCards.forEach(membershipServiceCard => {
          membershipServiceCard.addEventListener('click', this.handleServiceCard.bind(this));
        })
      }

      initMembershipServiceTabButtons() {
        const membershipServiceTabButtons = [...this.querySelectorAll(this.selectors.membershipServiceTabButton)];

        if (!membershipServiceTabButtons.length) return;

        this.membershipServiceTabButtons = membershipServiceTabButtons;

        this.membershipServiceTabButtons.forEach(membershipServiceTabButton => {
          membershipServiceTabButton.addEventListener('click', this.handleTabButton.bind(this));
        });
      }

      handleServiceCard(event) {
        const membershipServiceCard = event.target.closest(this.selectors.membershipServiceCard);
        const optionValueHandle = this.activeMembershipServiceTabButton?.dataset?.optionValueHandle || "";

        if (!optionValueHandle || !membershipServiceCard) return;

        this.activeMembershipServiceCard.classList.remove(this.classes.isActive);
        this.activeMembershipServiceCard = membershipServiceCard;
        this.activeMembershipServiceCard.classList.add(this.classes.isActive);

        this.updateMembershipProducts(optionValueHandle);
      }

      handleTabButton(event) {
        const membershipServiceTabButton = event.target.closest(this.selectors.membershipServiceTabButton);
        const optionValueHandle = membershipServiceTabButton.dataset.optionValueHandle;

        if (!optionValueHandle) { return; }

        this.updateMembershipProducts(optionValueHandle);

        this.activeMembershipServiceTabButton.classList.remove(this.classes.isActive);
        this.activeMembershipServiceTabButton.disabled = false;

        this.activeMembershipServiceTabButton = membershipServiceTabButton;

        this.activeMembershipServiceTabButton.classList.add(this.classes.isActive);
        this.activeMembershipServiceTabButton.disabled = true;

        this.doubleCheckText && this.doubleCheckText.classList.toggle(this.classes.isActive, JSON.parse(this.doubleCheckText.dataset.doubleCheckTextPlans).includes(optionValueHandle));
      }

      updateMembershipProducts(optionValueHandle) {
        const membershipProducts = this.membershipProducts
            .flatMap(membershipProducts =>
                membershipProducts.sellingPlanAllocations
                    .filter(sellingPlanAllocation => sellingPlanAllocation.optionValueHandle === optionValueHandle)
                    .map(sellingPlanAllocation => ({
                          productId: membershipProducts.productId,
                          sellingPlanAllocation
                        })
                    )
            );

        this.membershipServiceCards.forEach(membershipServiceCard => {
          this.updateMembershipServiceCard(membershipServiceCard, membershipProducts)
        });

        this.updateFormSellingPlan(membershipProducts);
      }

      updateFormSellingPlan(membershipProducts) {
        const membershipServiceCardId = Number(this.activeMembershipServiceCard.dataset.productId);
        this.sellingPlanFormInput.value = membershipProducts.find(membershipProduct => membershipProduct.productId === membershipServiceCardId)?.sellingPlanAllocation?.id || 0;
      }

      updateMembershipServiceCard(membershipServiceCard, membershipProducts) {
        const membershipServiceCardId = Number(membershipServiceCard.dataset.productId);
        const relatedMembershipProduct = membershipProducts.find(membershipProduct => membershipProduct.productId === membershipServiceCardId);

        if (!relatedMembershipProduct) {
          membershipServiceCard.classList.add(this.classes.isHidden);
          return;
        }

        const membershipServiceCardCompareAtPrice = membershipServiceCard.querySelector(this.selectors.membershipServiceCardCompareAtPrice);
        const membershipServiceCardPrice = membershipServiceCard.querySelector(this.selectors.membershipServiceCardPrice);
        const membershipServiceCardPriceDuration = membershipServiceCard.querySelector(this.selectors.membershipServiceCardPriceDuration);

        const perDeliveryCompareAtPrice = relatedMembershipProduct.sellingPlanAllocation.perDeliveryCompareAtPrice;
        const perDeliveryPrice = relatedMembershipProduct.sellingPlanAllocation.perDeliveryPrice;
        const priceDuration = relatedMembershipProduct.sellingPlanAllocation.priceDuration;

        if (membershipServiceCardCompareAtPrice) {
          membershipServiceCardCompareAtPrice.classList.toggle(this.classes.isHidden, !perDeliveryCompareAtPrice);
          membershipServiceCardCompareAtPrice.innerText = perDeliveryCompareAtPrice;
        }

        if (membershipServiceCardPrice) {
          membershipServiceCardPrice.innerText = perDeliveryPrice;
        }

        if (membershipServiceCardPriceDuration) {
          membershipServiceCardPriceDuration.classList.toggle(this.classes.isHidden, !priceDuration);
          membershipServiceCardPriceDuration.innerHTML = priceDuration;
        }

        membershipServiceCard.classList.remove(this.classes.isHidden);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const clickedSubmitButton = evt.submitter || this.submitButton;
        const clickedSubmitButtonSpinner = clickedSubmitButton?.querySelector('.loading__spinner');
        if (clickedSubmitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        clickedSubmitButton.setAttribute('aria-disabled', true);
        clickedSubmitButton.classList.add('loading');
        if (clickedSubmitButtonSpinner) {
          clickedSubmitButtonSpinner.classList.remove('hidden');
        }

        if(this.stickySubmitButton) {
          this.stickySubmitButton.setAttribute('aria-disabled', true);
          this.stickySubmitButton.classList.add('loading');
          this.stickySubmitButtonLoadingSpinner.classList.remove('hidden');
        }

        try {
          const formData = new FormData(this.form);
          const mainVariantId = formData.get('id');
          const isAddWithoutMembership = evt.submitter?.dataset?.addWithoutMembership === 'true';
          const sellingPlanId = isAddWithoutMembership ? null : formData.get('selling_plan');
          const quantity  = document.querySelector('[name=quantity]')?.value ?? 1;
          const activeCard = this.querySelector(`${this.selectors.activeMembershipServiceCard}`);
          const activeCardTitle = activeCard?.querySelector(".membership-service-card__heading")?.textContent || "";
          const activeSubVariantId = activeCard?.dataset.variantId;
          const activeSellingPlan = this.querySelector(`${this.selectors.activeMembershipServiceTabButton}`);
          const activeSellingPlanValue = activeSellingPlan?.querySelector(".membership-service-tabs__button-text")?.textContent || "";
          const isMembershipsEnabled = this.hasAttribute("data-memberships-enabled") || false;
          const shouldAddMembershipItems = Boolean(sellingPlanId) && isMembershipsEnabled;

          const items = [{
            id: mainVariantId,
            quantity: quantity,
            ...(sellingPlanId && (isMembershipsEnabled
              ? {
                  properties: {
                    "Membership": `${activeCardTitle}, ${activeSellingPlanValue}`
                  }
                }
              : {
                  selling_plan: sellingPlanId
                }
            ))
          }];

          if (activeSubVariantId && shouldAddMembershipItems) {
            items.push({
              id: activeSubVariantId,
              quantity: quantity,
              selling_plan: sellingPlanId,
              properties: {
                _mainSubProduct: mainVariantId
              }
            });
          }

          const sections = this.cart?.getSectionsToRender().map(section => section.id) || [];
          const payload = {
            items,
            sections,
            sections_url: window.location.pathname
          };

          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });

          const cartData = await response.json();

          if (cartData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: cartData.errors || cartData.description,
              message: cartData.message
            });
            this.handleErrorMessage(cartData.description);

            const soldOutMessage = clickedSubmitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            clickedSubmitButton.setAttribute('aria-disabled', true);
            const clickedSubmitButtonText = clickedSubmitButton.querySelector('span');
            if (clickedSubmitButtonText) {
              clickedSubmitButtonText.classList.add('hidden');
            }
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

         const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId,
              cartData
            }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(cartData);
                    });
                  });
                },
                { once: true }
            );
            quickAddModal.hide(true);
          } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(cartData);
              });
          }
        } catch (error) {
          console.error(error);
        } finally {
          clickedSubmitButton.classList.remove('loading');

          if(this.stickySubmitButton) {
            this.stickySubmitButton.classList.remove('loading');
          }

          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

          if (!this.error) {
            clickedSubmitButton.removeAttribute('aria-disabled');

            if(this.stickySubmitButton) {
              this.stickySubmitButton.removeAttribute('aria-disabled')
            }
          }

          if (clickedSubmitButtonSpinner) {
            clickedSubmitButtonSpinner.classList.add('hidden');
          }

          if(this.stickySubmitButton) {
            this.stickySubmitButtonLoadingSpinner.classList.add('hidden');
          }
        }
        CartPerformance.measureFromEvent("add:user-action", evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if(this.stickySubmitButton) {
            this.stickySubmitButton.setAttribute('disabled', 'disabled');
          }

          if (!text) return;

          this.submitButtonText.textContent = text;

          if(this.stickySubmitButton) {
            this.stickySubmitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;

          if(this.stickySubmitButton) {
            this.stickySubmitButton.removeAttribute('disabled');
            this.stickySubmitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
